import { render, staticRenderFns } from "./Bgjurisdiction.vue?vue&type=template&id=984fdfac&scoped=true&"
import script from "./Bgjurisdiction.vue?vue&type=script&lang=js&"
export * from "./Bgjurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./Bgjurisdiction.vue?vue&type=style&index=0&id=984fdfac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984fdfac",
  null
  
)

export default component.exports